import { Form, useFormikContext } from 'formik';
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../../components/button';
import text from '../../text';
import FormContainer from '../../components/containers/FormContainer';
import Control from '../../components/form/Control';
var ForgotPasswordForm = function() {
    var _useFormikContext = useFormikContext(), values = _useFormikContext.values, touched = _useFormikContext.touched, errors = _useFormikContext.errors, handleChange = _useFormikContext.handleChange, isSubmitting = _useFormikContext.isSubmitting, handleBlur = _useFormikContext.handleBlur, dirty = _useFormikContext.dirty, isValid = _useFormikContext.isValid;
    return /*#__PURE__*/ React.createElement(FormContainer, null, /*#__PURE__*/ React.createElement(FormContainer.SecondaryHeader, null, /*#__PURE__*/ React.createElement("h2", null, text('forgotYourPassword'))), /*#__PURE__*/ React.createElement(FormContainer.Body, null, /*#__PURE__*/ React.createElement(FormContainer.PrimaryHeader, null, /*#__PURE__*/ React.createElement("h2", null, text('forgotYourPassword'))), /*#__PURE__*/ React.createElement(Form, null, /*#__PURE__*/ React.createElement(Control, {
        as: "input",
        type: "text",
        name: "email",
        value: (values === null || values === void 0 ? void 0 : values.email) || '',
        onChange: handleChange,
        onBlur: handleBlur,
        placeholder: text('email'),
        isFailed: touched.email && Boolean(errors.email),
        validationError: errors.email
    }), /*#__PURE__*/ React.createElement("div", {
        className: "text-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "btns-group"
    }, /*#__PURE__*/ React.createElement(Button, {
        type: !isSubmitting && 'submit',
        className: "full-width",
        loading: isSubmitting,
        disabled: !(dirty && isValid)
    }, text('submit'))), /*#__PURE__*/ React.createElement("p", {
        className: "small-text"
    }, /*#__PURE__*/ React.createElement(Link, {
        to: "/"
    }, text('cancel')))))));
};
export default ForgotPasswordForm;
